import { render, staticRenderFns } from "./OpenPositionsDetailThankYou.vue?vue&type=template&id=04bf4051"
import script from "./OpenPositionsDetailThankYou.vue?vue&type=script&lang=js"
export * from "./OpenPositionsDetailThankYou.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports